import script from "./create-office-button.vue?vue&type=script&lang=js"
export * from "./create-office-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__